import React from 'react';
import PropTypes from 'prop-types';
import {cn} from "@bem-react/classname";

import './style.scss';

const Button = ({children, onClick, className, disabled, active, ...attr}) => {

    const inputCn = cn(className);

    const onClickAction = e => {
        if (disabled) {
            e.preventDefault()
        } else {
            return onClick(e)
        }
    }


    const Tag = attr.href ? 'a' : 'button'

    return (
        <Tag
            className={`${inputCn('btn')} btn`}
            disabled={disabled}
            onClick={onClickAction}
            {...attr}
        >
            {children}
        </Tag>
    )
}

Button.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    active: PropTypes.bool,
}

Button.defaultProps = {
    children: 'Default Text',
    onClick: () => {},
    className: '',
    disabled: false,
    active: false,
}

export default Button;